import type { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { ToastMessageService } from '../../shared/services/toast-message.service';
import { inject } from '@angular/core';
import { LogoutService } from '../auth/logout.service';
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const _ToastMessageService = inject(ToastMessageService);
  const _logoutService = inject(LogoutService);

  function handleErrorMessage(error: any) {
    error?.error.Error[0].split(',').forEach((err: any) => {

      _ToastMessageService.toastOnError('error', err)
    })
  }

  return next(req).pipe(map(
    (event: HttpEvent<any>) => {
      return event;
    }
  ),

    catchError(
      (error: HttpErrorResponse) => {
        switch (error.status) {
          case 401:
            _ToastMessageService.toastOnError('error', error?.error.Error[0])
            _logoutService.logout();
            // handle not Authenticated case here
            break;

          case 403:
            handleErrorMessage(error);
            // handle not Authorized case here
            break;

          case 404:
            handleErrorMessage(error);
            // handle not found case here
            break;
          case 500:
            // handle server error case here
            handleErrorMessage(error);
            break;
          default:
            handleErrorMessage(error);
            break;
        }

        return throwError(() => error);
      })
  );
};

